import {notificationsTestActions} from "./reducers";

export const SET_SELECTED_USER: string = notificationsTestActions.setSelectedUser.type;
export const UPDATE_ANY_FIELD_OF_USER: string = notificationsTestActions.updateAnyFieldOfUser.type;
export const UPDATE_WHOLE_OBJECT_OF_USER: string = notificationsTestActions.updateWholeObjectOfUser.type;

export const APPROVE_USER_PERMISSIONS: string = "APPROVE_USER_PERMISSIONS";
export const DECLINE_USER_PERMISSIONS: string = "DECLINE_USER_PERMISSIONS";
